import {CustomModal} from "../../modules/CustomModal";
import {OfferSwitcher} from "../Card/OfferSwitcherAB";

export class AddCombo {
    constructor(id, callback = null) {
        $('body').preloader('show');

        this.callback = callback;

        this.process(id);
    }
    process(id) {
        let $this = this,
            offersBlock = $('.js-offer-switcher'),
            shownModal = $('.modal.in');

        $.post('/ajax/basket/add_combo/', {id: id}, (result) => {
            if (!result.hasOwnProperty('type')) {
                console.error(result);

                return;
            }

            switch (result.type) {
                case 'success':
                    // Google AdWords old site dataLayer
                    try {
                        window.dataLayer.push({
                            'ecomm_event': 'cart_add',
                            'total_value': $('.card__price').data('price'),
                            'product_ids': id
                        });
                    } catch (exception) {}

                    try {
                        window.APRT_SEND({
                            pageType: 8,
                            currentProduct: {
                                id: id,
                                name: $('.card-h1').text(),
                                price: $('.card__price').data('price')
                            }
                        });
                    } catch (e) {}

                    try {
                        rrApi.addToBasket(id)
                    } catch(e) {}

                    refreshHeaderBasket();
                    refreshOffersArray(id, 'add', offersBlock.data('product'));

                    offersBlock.bindToEntity(OfferSwitcher);

//                    $('.js-ab-add_to_basket').hide();
//                    $('.js-ab-add_to_basket_success').show();

                    if ($this.callback) {
                        $this.callback();
                    }
                    break;

                case 'error':
                    console.error(result.value);

                    if (shownModal && shownModal.length > 0) {
                        shownModal.modal('hide');
                    }

                    let modal = new CustomModal();

                    modal.show('Во время добавления произошла ошибка', result.value);

                    $('body').preloader('hide');
                    break;
            }
        }, 'json');
    }
}
